import { IDict } from "./types";

export const it: IDict = {
  Jobs: "Lavori",
  "No Jobs": "Nessun Lavoro",
  Billing: "Fatturazione",
  Credits: "Crediti",
  "Pay Per Use": "Pay Per Use",
  "Feature Voting": "Votazione delle Funzionalità",
  "Free Karaoke Left": "Karaoke Gratuiti Rimasti",
  "Upgrade Now to Create More": "Aggiorna Ora per Crearne Altri",
  "Storage is Full": "Memoria piena",
  "Youka is running out of storage space":
    "Youka sta esaurendo lo spazio di archiviazione",
  "Please free up at least 1 GB before creating new karaoke":
    "Si prega di liberare almeno 1 GB prima di creare un nuovo karaoke",
  "Click the button to check again":
    "Clicca il pulsante per controllare di nuovo",
  "No Internet Connection": "Nessuna connessione Internet",
  "Youka cannot connect to the internet":
    "Youka non può connettersi a Internet",
  "Please make sure you have internet connection":
    "Assicurati di avere una connessione internet",
  "Update is ready": "L'aggiornamento è pronto",
  "Click the button to update": "Clicca il pulsante per aggiornare",
  "Library Folder": "Cartella della Biblioteca",
  "Export Folder": "Cartella di Esportazione",
  "Sync Model": "Modello di Sincronizzazione",
  "Max Video Quality": "Qualità Video Massima",
  "Speed / Compression Preset": "Preset Velocità / Compressione",
  Change: "Cambia",
  "dialogs.upgrade.upgrade_to_pro":
    "La funzionalità che stai cercando fa parte del piano Pro, aggiorna ora per sbloccare questa funzionalità.",
  "dialogs.upgrade.upgrade_to_standard":
    "La funzionalità che stai cercando fa parte del piano Standard, aggiorna ora per sbloccare questa funzionalità.",
  heads_up: "Attenzione!",
  "dialogs.edit_lyrics.not_supported":
    "La lingua che hai scelto non è attualmente supportata per la sincronizzazione automatica dei testi. Tuttavia, puoi salvare i tuoi progressi e quindi utilizzare l'editor del livello di linea per sincronizzare manualmente i testi.",
  "dialogs.create.title": "Crea nuovo karaoke",
  "dialogs.create.description":
    "Si prega di compilare il modulo sottostante per creare un nuovo karaoke, è possibile utilizzare file audio o video, i testi sono facoltativi.",
  "dialogs.edit_lyrics.description":
    "Dopo il salvataggio, verrà avviato il processo di sincronizzazione, puoi seguire l'avanzamento nella scheda Lavori",
  "dialogs.upgrade.see_plans": "Vedi Piani",
  "dialogs.upgrade.unlock": "Sblocca",
  "comps.sync_editor.attach_previous": "Collega alla parola precedente",
  "comps.sync_editor.attach_next": "Collega alla parola successiva",
  "comps.plans.title":
    "Scegli il piano che meglio si adatta alle tue esigenze. È sempre possibile effettuare l'upgrade o il downgrade",
  "Font Size": "Dimensione Carattere",
  Spacing: "Spaziatura",
  Outline: "Contorno",
  "Margin Bottom": "Margine Inferiore",
  "Max Chars per Line": "Max Caratteri per Linea",
  Bold: "Grassetto",
  Italic: "Corsivo",
  Shadow: "Ombra",
  month: "mese",
  songs: "canzoni",
  Title: "Titolo",
  "Save and Sync": "Salva e Sincronizza",
  Lyrics: "Testi",
  Update: "Aggiorna",
  Playlist: "Playlist",
  Canceling: "Annullamento",
  Play: "Riproduci",
  "Lyrics Language": "Lingua dei Testi",
  "Background Image": "Immagine di Sfondo",
  "Basic Version": "Versione Base",
  "Standard Version": "Versione Standard",
  "Pro Version": "Versione Pro",
  "Trial Version": "Versione di Prova",
  "No Active Plan": "Nessun Piano Attivo",
  "Days Left in Trial": "Giorni Rimanenti nella Prova",
  Paste: "Incolla",
  "Sync Lyrics": "Sincronizza Testi",
  Show: "Mostra",
  Settings: "Impostazioni",
  Retry: "Riprova",
  "Create Karaoke": "Crea Karaoke",
  Canceled: "Annullato",
  Reset: "Reimposta",
  "Edit Video": "Modifica Video",
  Download: "Scarica",
  "Edit Metadata": "Modifica Metadati",
  "Subtitle Designer": "Progettista Sottotitoli",
  Export: "Esporta",
  year: "anno",
  Basic: "Base",
  Standard: "Standard",
  Pro: "Pro",
  Accept: "Accetta",
  "Add new word": "Aggiungi nuova parola",
  "Add to queue": "Aggiungi alla coda",
  "An unknown error occurred": "Si è verificato un errore sconosciuto",
  Annually: "Annualmente",
  "Are you sure you want to delete this karaoke song?":
    "Sei sicuro di voler eliminare questa canzone karaoke?",
  "Artist Name": "Nome Artista",
  "Audio or Video File": "File Audio o Video",
  Audio: "Audio",
  "Auto Karaoke Generator": "Generatore Automatico di Karaoke",
  "Auto Lyrics Sync": "Sincronizzazione Automatica dei Testi",
  "Cancel Plan": "Annulla Piano",
  Cancel: "Annulla",
  Close: "Chiudi",
  "Create Karaoke from song": "Crea Karaoke dalla Canzone",
  "Create Karaoke from local files": "Crea Karaoke da file locali",
  "Create new karaoke": "Crea nuovo karaoke",
  Create: "Crea",
  "Current Plan": "Piano Attuale",
  "Dark Mode": "Modalità Scuro",
  Decline: "Rifiuta",
  "Delete word": "Elimina parola",
  Delete: "Elimina",
  "Edit Lyrics": "Modifica Testi",
  Edit: "Modifica",
  "Export to mp3/mp4": "Esporta in mp3/mp4",
  "Go Back to EULA": "Torna all'EULA",
  "Go back": "Torna indietro",
  "Go forward": "Vai avanti",
  Home: "Home",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "Accetto i termini e mi impegno ad evitare l'uso non autorizzato di contenuti protetti da copyright",
  Instruments: "Strumenti",
  Key: "Tonalità",
  Library: "Libreria",
  "Light Mode": "Modalità Chiaro",
  "Line Level Sync": "Sincronizzazione Livello Linea",
  "Line Level": "Livello Linea",
  "Lyrics (optional)": "Testi (facoltativo)",
  "Lyrics Sync Editor": "Editor di Sincronizzazione Testi",
  Manage: "Gestisci",
  Monthly: "Mensilmente",
  "Most popular": "Più popolare",
  "No new notifications": "Nessuna nuova notifica",
  "No results": "Nessun risultato",
  "No songs in library": "Nessuna canzone in libreria",
  "No songs in queue": "Nessuna canzone in coda",
  Notifications: "Notifiche",
  Off: "Spento",
  Or: "O",
  "Plan canceled, will end in": "Piano annullato, terminerà in",
  "Play word in loop": "Riproduci parola in loop",
  "Preparing Youka": "Preparazione di Youka",
  "Process 2 karaokes at a time": "Elabora 2 karaoke alla volta",
  "Process 5 karaokes at a time": "Elabora 5 karaoke alla volta",
  Queue: "Coda",
  Ready: "Pronto",
  "Remove from queue": "Rimuovi dalla coda",
  "Resume plan": "Riprendi piano",
  "Save and Resync": "Salva e Risincronizza",
  Save: "Salva",
  "Saving...": "Salvataggio in corso...",
  Search: "Cerca",
  "Select plan": "Seleziona piano",
  "Sign In": "Accedi",
  "Sign Out": "Esci",
  "Sign Up": "Registrati",
  "Song Name": "Nome Canzone",
  "Start typing to search or paste YouTube URL":
    "Inizia a digitare per cercare o incolla URL di YouTube",
  "Start typing to search": "Inizia a digitare per cercare",
  "Subtitle Track": "Traccia Sottotitoli",
  Subtitles: "Sottotitoli",
  Tempo: "Tempo",
  "Terms and Conditions": "Termini e Condizioni",
  "This action cannot be undone.": "Questa azione non può essere annullata.",
  "Thumbnail URL": "URL Miniatura",
  "To keep the karaoke fun going, please upgrade":
    "Per continuare a divertirti con il karaoke, si prega di effettuare l'upgrade",
  "Unlock Premium Features with an Upgrade!":
    "Sblocca Funzionalità Premium con un Upgrade!",
  "Update Payment Method": "Aggiorna Metodo di Pagamento",
  "Upgrade to Pro plan to enable":
    "Effettua l'upgrade al piano Pro per abilitare",
  Upgrade: "Upgrade",
  Version: "Versione",
  Video: "Video",
  Vocals: "Voci",
  "Waiting in queue": "In attesa nella coda",
  "Word Level Sync": "Sincronizzazione Livello Parola",
  "Word Level": "Livello Parola",
  "You need to accept the EULA to use Youka":
    "È necessario accettare l'EULA per utilizzare Youka",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "I tuoi testi sono stati salvati con successo. È in corso una risincronizzazione. Puoi monitorare il progresso nell'area notifiche. Una volta completata la risincronizzazione, potrai vedere le modifiche - basta premere 'riproduci'.",
  "Your trial version of Youka has expired":
    "La tua versione di prova di Youka è scaduta",
  "dialogs.youtube.title":
    "Installa il plugin yt-dlp per cercare e riprodurre video online",
  "dialogs.youtube.description":
    "Si prega di leggere e accettare i seguenti avvisi prima di abilitare il plugin.",
  "dialogs.youtube.agree": "Ho letto e compreso gli avvisi sopra",
  "dialogs.youtube.install": "Installa Plugin",
  "dialogs.youtube.install_success": "Plugin installato con successo",
  "dialogs.youtube.install_success_description":
    "Ora puoi cercare e riprodurre video online",
  "dialogs.youtube.install_error": "Installazione del Plugin fallita",
  "alert.youtube.description":
    "Il Plugin di Ricerca e Download di Video Online (yt-dlp) non è preinstallato. Clicca per installare il plugin.",
  "alert.youtube.install": "Installa Plugin",
  "dialogs.settings.enable_youtube": "Abilita il Plugin yt-dlp",
  "dialogs.youtube.warnings": [
    {
      title: "Conformità Legale",
      description:
        "Assicurati che il tuo uso di questo plugin sia in piena conformità con tutte le leggi applicabili e i termini di servizio di qualsiasi piattaforma con cui interagisci, come YouTube.",
    },
    {
      title: "Diritto d'Autore e Licenze",
      description:
        "Questo plugin può permettere azioni (come il download di contenuti) che potrebbero violare le leggi sul diritto d'autore o gli accordi di licenza se non utilizzato correttamente. È fondamentale rispettare i diritti dei creatori di contenuti e usare il plugin solo per scopi legalmente permessi.",
    },
    {
      title: "Nessuna Approvazione",
      description:
        "L'abilitazione di questo plugin non implica un'approvazione o un supporto da parte della nostra azienda. Il plugin è un'entità separata e non siamo responsabili per il suo funzionamento o per qualsiasi conseguenza del suo utilizzo.",
    },
    {
      title: "Responsabilità dell'Utente",
      description:
        "Sei l'unico responsabile per qualsiasi azione intraprendi utilizzando questo plugin. Ciò include qualsiasi conseguenza legale che possa derivare da un uso improprio o dalla violazione dei termini di servizio.",
    },
    {
      title: "Rischi Potenziali",
      description:
        "Sii consapevole che un uso improprio del plugin potrebbe portare alla sospensione dell'account o ad azioni legali da parte delle parti interessate o delle piattaforme.",
    },
    {
      title: "Consenso Informato",
      description:
        "Procedendo con l'abilitazione di questo plugin, riconosci di aver letto e compreso questi avvertimenti e accetti la piena responsabilità per l'uso del plugin.",
    },
  ],
  "model.auto": "Seleziona automaticamente il modello migliore.",
  "model.audioshake.transcription":
    "Il primo modello migliore, che prevede la trascrizione e il successivo allineamento, offre risultati superiori ma è accessibile esclusivamente agli utenti Pay Per Use e Trial (richiede fino a 10 minuti).",
  "model.audioshake":
    "Il 2° modello migliore si allinea con i testi forniti, dove le imprecisioni possono portare a risultati non ottimali (richiedendo fino a 10 minuti).",
  "model.wav2vec2":
    "Il terzo modello migliore, si allinea con i testi forniti, dove le imprecisioni possono portare a risultati non ottimali, supporta quasi tutte le lingue. (richiede fino a 30 secondi)",
  "model.whisper":
    "Il quarto modello migliore, che prevede la trascrizione e il successivo allineamento. I testi in uscita potrebbero non essere accurati, sebbene la sincronizzazione sia accettabile (richiede fino a 2 minuti).",
  "sync.line.instructions": [
    "Fai clic sul pulsante Riproduci per riprodurre il brano e avviare il processo di sincronizzazione",
    "Fai clic sul pulsante Imposta inizio quando senti la prima parola della riga corrente",
    "Fare clic sul pulsante Imposta fine dopo aver ascoltato l'ultima parola della riga corrente",
    "Continua fino al termine della sincronizzazione di tutte le linee",
  ],
  Undo: "Annulla",
  Redo: "Rifai",
  "Set Start": "Imposta Inizio",
  "Set End": "Imposta Fine",
  "dialogs.edit_lyrics.transcription":
    "Quando si utilizza il modello di trascrizione, il modello trascrive autonomamente la canzone e identifica il testo da solo, senza fare affidamento su alcun testo fornito. Successivamente, hai la possibilità di regolare i testi utilizzando lo strumento di sincronizzazione.",

  "Duet Editor": "Editor Duet",
  "Manual Line Sync": "Sincronizzazione Manuale di Linea",
  "New Style": "Nuovo Stile",
  Style: "Stile",
  Singer: "Cantante",
  "Style Editor": "Editor di Stile",
  Word: "Parola",
  Line: "Linea",
  "Split Line": "Dividi Linea",
  "Upgrade to Enable": "Aggiorna per Abilitare",
  upgrade_description:
    "Hai la possibilità di ascoltare o scaricare le tracce karaoke che hai già generato. Tuttavia, se desideri creare tracce karaoke aggiuntive, è necessario un aggiornamento.",
  "dialogs.global.no_user.title": "Nessun Piano Attivo",
  "dialogs.global.no_user.description":
    "Si prega di passare a un piano per continuare.",
  "dialogs.global.no_role.title": "Nessun Piano Attivo",
  "dialogs.global.no_role.description":
    "Si prega di passare a un piano per continuare.",
  "dialogs.global.blocked_ip.title": "Il tuo IP è bloccato",
  "dialogs.global.blocked_ip.description":
    "Si prega di contattare il supporto.",
  "dialogs.global.rate_limit.title": "Limite di Velocità Superato",
  "dialogs.global.rate_limit.description":
    "È possibile passare a un piano Pay Per Use per accesso illimitato.",
  "dialogs.global.disk_full.title": "Il magazzino è pieno",
  "dialogs.global.disk_full.description":
    "Libera spazio per continuare a utilizzare Youka",
  "dialogs.global.too_big.title":
    "Il file audio supera il limite di dimensione.",
  "dialogs.global.too_big.description":
    "Si ricorda che il file audio non può superare la durata massima di 15 minuti.",
  Help: "Aiuto",
  Original: "Originale",
  Sort: "Ordina",
  "sort.date.asc": "Data di creazione (dal più vecchio al più recente)",
  "sort.date.desc": "Data di creazione (dal più recente al più vecchio)",
  "sort.title.asc": "Titolo (dalla A alla Z)",
  "sort.title.desc": "Titolo (dalla Z alla A)",
  Start: "Inizio",
  End: "Fine",
  Time: "Tempo",
  "dialogs.trim.title": "Taglia",
  "dialogs.trim.description":
    "Usa il bordo regolabile sulla forma d'onda per scegliere la parte della canzone che vuoi mantenere.",
  Related: "Correlate",
  preserve_vocals: "Preservare le Voci",
  preserve_vocals_description:
    "Attiva questo per preservare le voci come i cori di sottofondo.",
  "Separate Audio": "Separare Audio",
  "Separate Model": "Modello Separato",
  "Add Lyrics": "Aggiungi Testi",
  "Background Image or Video": "Immagine o Video di Sfondo",
  Docs: "Documenti",
  Watch: "Guarda",
  Hide: "Nascondi",
  "watch.sync.title":
    "Come risolvere facilmente la sincronizzazione dei testi?",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  Review: "Recensione",
  "watch.review.title": "Recensisci Youka su Trustpilot",
  "Import Subtitles": "Importa Sottotitoli",
  Import: "Importa",
  "How to use": "Come usare",
  Uppercase: "Maiuscolo",
  "Open Dual Screen": "Apri Schermo Duplicato",
  "Close Dual Screen": "Chiudi Schermo Duplicato",
  "Import Karaoke File": "Importa File Karaoke",
  "dialogs.import_karaoke.title": "Importa Karaoke da File",
  "dialogs.import_karaoke.description":
    "Importa un file karaoke esistente, come un MP3/MP4 con testi incorporati, un file LRC con lo stesso nome, o un file Karafun.",
  optional: "opzionale",
  "Trial Expired": "Prova Scaduta",
  "Subtitles Settings": "Impostazioni Sottotitoli",
  Milliseconds: "Millisecondi",
  Seconds: "Secondi",
  Text: "Testo",
  Enabled: "Abilitato",
  Duration: "Durata",
  Gap: "Gap",
  Offset: "Offset",
  "Min Duration": "Durata Minima",
  "Max Duration": "Durata Massima",
  "Fade In": "Fade In",
  "Fade Out": "Fade Out",
  "plugins.title.title": "Mostra il Titolo della Canzone",
  "plugins.title.description":
    "Mostra il titolo della canzone all'inizio del video",
  "plugins.gap_text.title": "Testo di Gap Silenzioso",
  "plugins.gap_text.description": "Mostra il testo nel gap tra i sottotitoli",
  "plugins.gap_progress_bar.title": "Barra di Progressione di Gap Silenzioso",
  "plugins.gap_progress_bar.description":
    "Mostra una barra di progressione nel gap tra i sottotitoli",
  "plugins.fade.title": "Effetto Fade",
  "plugins.fade.description":
    "Mostra l'effetto Fade in e Fade out dei sottotitoli",
  "plugins.offset.title": "Offset",
  "plugins.offset.description":
    "Sposta i sottotitoli di una certa quantità di secondi",
  "plugins.countdown.title": "Conto alla rovescia di Gap Silenzioso",
  "plugins.countdown.description":
    "Mostra un conto alla rovescia nel gap tra i sottotitoli",
  Auto: "Automatico",
  Subword: "Sottoparola",
  Countdown: "Conto alla rovescia",
  "Restart required": "Riavviare richiesto",
  "Reindex Library": "Rieindice la Libreria",
  "Create playlist": "Crea playlist",
  "Are you sure you want to delete?": "Sei sicuro di voler eliminare?",
  "Add to playlist": "Aggiungi alla playlist",
  "New playlist": "Nuova playlist",
  "Remove from this playlist": "Rimuovi da questa playlist",
  Songs: "Canzoni",
  Playlists: "Playlists",
  Name: "Nome",
  Photo: "Foto",
  "No playlists": "Nessuna playlist",
  "Welcome to Youka": "Benvenuto in Youka",
  "Search songs online": "Cerca canzoni online",
  "create.file.title": "Crea Karaoke da un file",
  "create.file.description":
    "Carica il tuo file MP3, MP4 o altri formati per creare istantaneamente un video karaoke con testi sincronizzati.",
  "create.online.title": "Crea Karaoke da canzoni online",
  "create.online.description":
    "Cerca canzoni online o incolla l'URL di una canzone per creare istantaneamente un video karaoke con testi sincronizzati.",
  "Change Background": "Cambia Sfondo",
  "Duet Line Split": "Dividi Linea di Duetto",
  Both: "Entrambi",
  Custom: "Personalizzato",
  Edited: "Modificato",
  Trimmed: "Tagliato",
  Instrumental: "Instrumentale",
  "Add Subword": "Aggiungi Sottoparola",
  "plugins.max_chars.title": "Caratteri massimi per riga",
  "plugins.max_chars.description": "Limitare il numero di caratteri per riga",
  Limit: "Limite",
  "Background Box": "Casella di Sfondo",
  Height: "Altezza",
  Width: "Larghezza",
  Alpha: "Alfa",
  Color: "Colore",
  Duplicate: "Duplica",
  "Convert to 16x9": "Converti in 16x9",
  "Resize Video": "Ridimensiona il Video",
  "Line Alignment": "Allinea Linea",
  "Shadow Color": "Colore di Ombra",
  "Outline Color": "Colore di Contorno",
  "Active Color": "Colore Attivo",
  "Secondary Color": "Colore Secondario",
  "Primary Color": "Colore Principale",
  "Auto Alignment": "Allinea Automaticamente",
  "Auto Color": "Colore Automatico",
  "Singer 1": "Cantante 1",
  "Singer 2": "Cantante 2",
  "Top Row": "Riga Superiore",
  "Bottom Row": "Riga Inferiore",
  "Border Style": "Stile di Bordo",
  "Font Name": "Nome del Font",
  "Experimental Subtitles Display": "Mostra i Sottotitoli Esperimentali",
  Position: "Posizione",
  "Timing Indicator": "Indicatore di Tempo",
  General: "Generale",
  Styles: "Stili",
  Thumbnail: "Miniatura",
  "create.url.title": "Crea Karaoke da URL",
  "create.url.description": "Crea karaoke da un URL compatibile con yt-dlp",
  "Paste a URL or start typing to search":
    "Incolla un URL o inizia a digitare per cercare",
  Top: "In alto",
  Bottom: "In basso",
  Center: "Al centro",
  "Auto Line Break": "Dividi Linea Automaticamente",
  "Fill Color": "Colore di Rilevamento",
  "Active Line Color": "Colore di Linea Attiva",
  "Waiting Line Color": "Colore di Linea in Attesa",
  "Set as Default": "Imposta come Predefinito",
  Default: "Predefinito",
  "Make Default": "Imposta come Predefinito",
  Image: "Immagine",
  Pause: "Pausa",
  File: "File",
  "Debug Info": "Informazioni di Debug",
  "File Type": "Tipo di File",
  Language: "Lingua",
  "Reset Settings": "Resetta Impostazioni",
  "Failed to start Youka": "Errore durante l'avvio di Youka",
  Legacy: "Tradizionale",
  Transcription: "Trascrizione",
  Alignment: "Allineamento",
  Imported: "Importato",
  "With Backing Vocals": "Con Voci di Fondo",
  Stem: "Stem",
  Clear: "Cancella",
  "Open Directory": "Apri Directory",
  "Advanced Settings": "Impostazioni Avanzate",
  "How to Add a Background Black Box to Subtitles":
    "Come aggiungere una scatola nera di sfondo ai sottotitoli",
  "How to Adjust the Line Length": "Come regolare la lunghezza della riga",
  "How to Cancel Your Subscription": "Come annullare l'abbonamento",
  "How to Center Subtitles": "Come centrare i sottotitoli",
  "How to Delete a Karaoke": "Come eliminare un karaoke",
  "How to Edit the lyrics": "Come modificare i testi",
  "How to Fix the Sync": "Come correggere la sincronizzazione",
  "How to Keep Choirs": "Come mantenere i cori",
  "How to Keep the Original Singer’s Voice":
    "Come mantenere la voce originale del cantante",
  "How to Set Up a Duet": "Come configurare un duetto",
  "How to Speed Up the Download Process":
    "Come velocizzare il processo di download",
  "How to Transfer Your Karaoke Library to a New Computer":
    "Come trasferire la tua libreria di karaoke su un nuovo computer",
  "How to Trim a Karaoke Video": "Come tagliare un video di karaoke",
  FAQ: "FAQ",
  "library.description":
    "Accedi e gestisci tutte le tracce karaoke che hai creato. Modifica, organizza e perfeziona i tuoi progetti.",
  "How to Change the Background Video": "Come cambiare il video di sfondo",
  "Auto Size": "Tamaño Automático",
  "dialogs.global.no_credits.title": "Nessun credito disponibile",
  "dialogs.global.no_credits.description":
    "Per favore, ricarica i crediti per continuare",
  "Credits are over! Click to buy more":
    "I crediti sono terminati! Clicca per acquistarne di più",
  "How to Add a Line Break": "Come aggiungere un salto di linea",
  "dialogs.global.no_user.many_emails_description":
    "L'accesso è stato bloccato a causa di più accessi con indirizzi email diversi. Acquista un abbonamento per continuare.",
  "dialogs.global.no_user.virtual_machine_description":
    "L'accesso è stato bloccato perché stai utilizzando una macchina virtuale. Per accedere alla prova gratuita, installa Youka su un sistema operativo standard. Se hai un abbonamento, rinnovalo per riottenere l'accesso. Se non hai bisogno di generare karaoke in modo continuativo, puoi scegliere un piano a consumo, assicurandoti di pagare solo quando crei nuovi contenuti karaoke.",
  "Import Stem": "Importa Stem",
  "Active Outline Color": "Colore di Contorno Attivo",
  "Inactive Outline Color": "Colore di Contorno Inattivo",
  "Inactive Line Color": "Colore di Linea Inattiva",
  "Active Line": "Linea Attiva",
  "Inactive Line": "Linea Inattiva",
  "End Extra": "Extra alla fine",
  Expand: "Espandi",
  Collapse: "Riduci",
  "Copy Line": "Copia riga",
  "Copy Word": "Copia parola",
  "Cut Line": "Taglia riga",
  "Cut Word": "Taglia parola",
  "Delete Line": "Elimina riga",
  "Delete Subword": "Elimina sotto-parola",
  "Delete Word": "Elimina parola",
  "Add Line": "Aggiungi riga",
  "Add Word": "Aggiungi parola",
  // "Add Subword": "Aggiungi sotto-parola",
  "Paste Line": "Incolla riga",
  "Paste Word": "Incolla parola",
  "Paste Subword": "Incolla sotto-parola",
  "Play Line": "Riproduci riga",
  "Play Word": "Riproduci parola",
  "Select Line": "Seleziona riga",
  "Manual Sync": "Sincronizzazione manuale",
  "Trim Start": "Taglia inizio",
  "Trim End": "Taglia fine",
  "Creating will use 1 credit": "La creazione utilizzerà 1 credito",
  All: "Tutti",
  "Number of Singers": "Numero di cantanti",
  "Style Mapping": "Mappatura degli stili",
  "Associate subtitle styles with singers":
    "Associa gli stili dei sottotitoli ai cantanti",
  "Upper first line": "Prima riga superiore",
  "Upper second line": "Seconda riga superiore",
  "Lower first line": "Prima riga inferiore",
  "Lower second line": "Seconda riga inferiore",
  Lock: "Blocca",
  "2 Lines": "2 righe",
  "4 Lines": "4 righe",
  Static: "Statico",
  Dynamic: "Dinamico",
  "Subtitles Type": "Tipo di sottotitoli",
  "Danger Zone": "Zona pericolosa",
  Copy: "Copia",
  Copied: "Copiato",
  "Copy Settings": "Copia Impostazioni",
  "cta.social.title": "Ottieni 50 crediti GRATIS!",
  "cta.social.description":
    "Condividi un post su Youka sui social media, taggaci e guadagna 50 crediti gratuiti per piattaforma!",
  "cta.social.description.2":
    "Clicca per visitare la pagina Facebook di Youka, metti mi piace, condividi un post e invia la tua email nella chat per ricevere 50 crediti gratuiti!",
  "Merge Line": "Unisci riga",
  Player: "Lettore",
  "Key Step": "Passo di tonalità",
  "Tempo Step": "Passo di tempo",
  "Shift Line Forward": "Sposta riga in avanti",
  "Shift Line Backward": "Sposta riga indietro",
  "create.description":
    "Crea un karaoke da file audio o video (MP3, MP4 e altro), oppure incolla un URL per generare istantaneamente un video karaoke con testi sincronizzati.",
  "No file chosen": "Nessun file scelto",
  "Choose File": "Scegli un file",
  "Watch Quick Start Video": "Guarda il video di avvio rapido",
  "Export Settings": "Esporta impostazioni",
  "Import Settings": "Importa impostazioni",
  "Video Guides": "Guides di video",
  "Quick Start Guide": "Guida di avvio rapido",
  "Lyrics Sync Guide": "Guida di sincronizzazione dei testi",
  Resolution: "Risoluzione",
  "Subtitles Preset": "Preimpostazione sottotitoli",
  Preset: "Preimpostazione",
  Done: "Fatto",
  "New Style Mapping": "Nuova mappatura dello stile",
  Horizontal: "Orizzontale",
  Vertical: "Verticale",
  Square: "Quadrato",
  New: "Nuovo",
  "New Subtitles Preset": "Nuova preimpostazione sottotitoli",
  "Change Aspect Ratio": "Cambia proporzioni",
  "copyright.title.a": "Accetto la",
  "copyright.title.b": "Conferma di utilizzo della musica",
  "copyright.description":
    "Selezionando questa casella, confermi che (A) possiedi tutti i diritti sulla musica inclusa in questo video; oppure (B) la musica è di dominio pubblico; oppure (C) hai il permesso di tutti i titolari dei diritti necessari per utilizzare la musica sulla piattaforma Youka.",
  "Add Intro Video": "Aggiungi video introduttivo",
  "dialogs.intro.description":
    "Aggiungi un video personalizzato all'inizio del karaoke",
  Transition: "Transizione",
  Fade: "Dissolvenza",
  "Circle Open": "Cerchio aperto",
  "Circle Close": "Cerchio chiuso",
  "Diagonal Open": "Apertura diagonale",
  "Diagonal Close": "Chiusura diagonale",
  "Smooth Left": "Scorrimento sinistro",
  "Smooth Right": "Scorrimento destro",
  Squares: "Quadrati",
  Dissolve: "Dissolvenza",
  Type: "Tipo",
  "Song Title": "Titolo della canzone",
  Artists: "Cantanti",
  Artist: "Cantante",
  "Parse Titles": "Analizza i titoli",
  "sort.artist.asc": "Cantante (A a Z)",
  "sort.artist.desc": "Cantante (Z a A)",
  "Title Style": "Stile del titolo",
  "Artist Style": "Stile del cantante",
  "Analyse Library": "Analizza la libreria",
  "No Filter": "Nessun filtro",
  "credits.message_one": "Questo utilizzerà {{count}} credito",
  "credits.message_other": "Questo utilizzerà {{count}} crediti",
  "credits.badge_one": "{{count}} credito",
  "credits.badge_other": "{{count}} crediti",
  "Provide song lyrics to save credits":
    "Aggiungi testi delle canzoni per risparmiare crediti",
  "Upload to Cloud Library": "Carica nella libreria cloud",
  "Cloud Library": "Libreria cloud",
  "Open Cloud Library": "Apri libreria cloud",
};
